$(document).ready(function(){  
$('body').on('click','.block_free-gift-add-btn',function(e){
  e.preventDefault();
    var product_id = $(this).attr('data-id');   
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
          quantity: 1,
          id: product_id
      },
      dataType: 'json',
      success: function(data) {
          $.getJSON('/cart.json').then(cart => {
              fetch('/cart?view=item').then(response => response.text())
                  .then(text => {
                      const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                     console.log(sectionInnerHTML);
                      const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                      console.log(cartFormInnerHTML);
                  
                      // const totalPrice = sectionInnerHTML.querySelector('#AjaxCartForm .totals__total-value').innerHTML;
                      $('#AjaxCartForm').html(cartFormInnerHTML)
                      $('sidebar-drawer').removeClass('cart-is-empty')
                      $('.cart__form').removeClass('cart--empty')
                      if ($('.area--cart .icon-button__label').length === 0) {
                          const cartNumber = document.createElement('div')
                          cartNumber.className = 'cart-count-bubble'
                          cartNumber.innerHTML = `<span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} items</span>`
                          $('#cart-icon-bubble').append(cartNumber)
                      } else {
                          $('.area--cart .icon-button__label [data-header-cart-count][aria-hidden="true"]').each((_, count) => $(count).text(cart.item_count))
                      }
                      $('.area--cart')[0].click()
                      $('.site-overlay').on('click', () => {
                          $('#site-cart-sidebar').removeClass('active')
                          $('body').removeClass('overflow-hidden')
                      }) 
                    change_slider_location();
                  })
            
          });    
        render_cart();
      }
  });
});

$('body').on('click','.ctm_add_to_cart',function(e){
  e.preventDefault();
    var product_id = $(this).attr('data-id');   
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
          quantity: 1,
          id: product_id
      },
      dataType: 'json',
      success: function(data) {
        $.getJSON( "/cart.json", function( response ) {

              var gift_array = [];
              var cart_product_array = [];
              var giftproduct1 = parseInt(first_giftproduct_id),
               giftproduct2 = parseInt(second_giftproduct_id);
              response.items.forEach(function(item) {
                var item_id = item.id;
                cart_product_array.push(item_id);
              });

              console.log(response.total_price+' > '+first_gift_product_available_value);
              console.log(response.total_price+' >= '+second_gift_product_available_value);
                 if(response.total_price >= second_gift_product_available_value && second_gift_product_available_value != 0){
                   console.log('1');
                    if(second_giftproduct_id != ''){
                      if ($.inArray(giftproduct2, cart_product_array) == -1) {
                        giftpurchase_productadd(giftproduct2); 
                      } 
                    }else{}
                  }else if(response.total_price >= first_gift_product_available_value && first_gift_product_available_value != 0){
                   console.log('2');
                    if(first_giftproduct_id != ''){
                      if ($.inArray(giftproduct1, cart_product_array) == -1) {
                        giftpurchase_productadd(giftproduct1); 
                      } 
                    }else{}

                    if(second_giftproduct_id != ''){
                      if ($.inArray(giftproduct2, cart_product_array) <= 1) {
                        giftpurchase_productremove(giftproduct2); 
                      } 
                    }else{}
                   
                  }else if(response.total_price < first_gift_product_available_value && response.total_price < second_gift_product_available_value){
                   console.log('3');
                    if(first_giftproduct_id!= '' && second_giftproduct_id != ''){
                      console.log($.inArray(giftproduct1, cart_product_array));
                      console.log($.inArray(giftproduct2, cart_product_array));
                      if ($.inArray(giftproduct1, cart_product_array) == 0 && $.inArray(giftproduct2, cart_product_array) == 0) {
                        console.log('11');
                        gift_array.push(first_giftproduct_id, second_giftproduct_id);
                        var productval = gift_array.shift();
                        giftpurchase_productremove(productval); 
                      }
                      else if ($.inArray(giftproduct1, cart_product_array) <= 1 && $.inArray(giftproduct2, cart_product_array) == -1) {
                        console.log('12');
                        giftpurchase_productremove(giftproduct1); 
                      } else if ($.inArray(giftproduct1, cart_product_array) == -1 && $.inArray(giftproduct2, cart_product_array) <= 1) {
                        console.log('13');
                        giftpurchase_productremove(giftproduct2); 
                      }
                    }else if(first_giftproduct_id != '' && second_giftproduct_id == ''){
                      if ($.inArray(giftproduct1, cart_product_array) <= 1) {
                        giftpurchase_productremove(giftproduct1); 
                      } 
                    }else if(first_giftproduct_id == '' && second_giftproduct_id != ''){
                      if ($.inArray(giftproduct2, cart_product_array) <= 1) {
                        giftpurchase_productremove(giftproduct2); 
                      } 
                    }
                  }else if(response.total_price < first_gift_product_available_value){
                   console.log('4');
                    if(first_giftproduct_id != ''){
                      if ($.inArray(giftproduct1, cart_product_array) <= 1) {
                        giftpurchase_productremove(giftproduct1); 
                      } 
                    }
                  }else if(response.total_price > first_gift_product_available_value && response.total_price < second_gift_product_available_value){
                   console.log('5');
                   if(first_giftproduct_id != ''){
                      if ($.inArray(giftproduct1, cart_product_array) == -1) {
                        console.log('sa');
                        giftpurchase_productadd(giftproduct1); 
                      } 
                    }else{}
                    if(second_giftproduct_id != ''){
                      if ($.inArray(giftproduct2, cart_product_array) <= 1) {
                        giftpurchase_productremove(giftproduct2); 
                      } 
                    }
                   
                  }else if(response.total_price == 0){
                   console.log('6');
                   if(first_giftproduct_id!= '' && second_giftproduct_id != ''){
                      if ($.inArray(giftproduct1, cart_product_array) <= 1 && $.inArray(giftproduct2, cart_product_array) <= 1) {
                        gift_array.push(first_giftproduct_id, second_giftproduct_id);
                        var productval = gift_array.shift();
                        giftpurchase_productremove(productval); 
                      }
                      else if ($.inArray(giftproduct1, cart_product_array) <= 1 && $.inArray(giftproduct2, cart_product_array) == -1) {
                        giftpurchase_productremove(giftproduct1); 
                      } else if ($.inArray(giftproduct1, cart_product_array) == -1 && $.inArray(giftproduct2, cart_product_array) <= 1) {
                        giftpurchase_productremove(giftproduct2); 
                      }
                    }else if(first_giftproduct_id != '' && second_giftproduct_id == ''){
                      if ($.inArray(giftproduct1, cart_product_array) <= 1) {
                        giftpurchase_productremove(giftproduct1); 
                      } 
                    }else if(first_giftproduct_id == '' && second_giftproduct_id != ''){
                      if ($.inArray(giftproduct2, cart_product_array) <= 1) {
                        giftpurchase_productremove(giftproduct2); 
                      } 
                    }
                  }

              function giftpurchase_productadd(giftpurchase_product){
                      $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: {
                          quantity: 1,
                          id: giftpurchase_product,
                          properties: {
                            'Gift': 'OFFERT'
                           }
                        },
                        dataType: 'json',
                        success: function(response) {
                          console.log(giftpurchase_product,"giftpurchase_product")
                              fetch('?section_id=helper-cart')
                              .then((response) => response.text())
                              .then((responseText) => {
                                const sectionInnerHTML = new DOMParser().parseFromString(responseText, 'text/html');
                                const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                                const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
                                const newupdatecartPrice = sectionInnerHTML.getElementById('AjaxCartForm').dataset.carttotal;
                                const cartItems = document.getElementById('AjaxCartForm');
                                cartItems.innerHTML = cartFormInnerHTML;
                                cartItems.ajaxifyCartItems();
            
                                document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                                    elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                                });
                                document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
                                    elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
                                });
            
                                if ( alert !== null ) {
                                    this.form.prepend(alert);
                                } 
            
                                document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                                        console.log('dsd');
                              
                                const event = new Event('cart-updated');
                                current_this.dispatchEvent(event);
                                change_slider_location();
                              })
                              .catch((e) => {
                                change_slider_location();
                                console.error(e); 
                              });
                        },
                        error: function() {
                          change_slider_location();
                        }
                      });
                }

               function giftpurchase_productremove(giftpurchase_product){
                      console.log(giftpurchase_product);
                      $.ajax({
                        type: 'POST',
                        url: '/cart/change.js',
                        data: {
                          quantity: 0,
                          id: giftpurchase_product
                        },
                        dataType: 'json',
                        success: function(response) {
                          console.log(gift_array);
                          if(gift_array.length > 0){
                            var productval = gift_array.shift();
                            giftpurchase_productremove(productval); 
                          }else{
                             fetch('?section_id=helper-cart')
                              .then((response) => response.text())
                              .then((responseText) => {
                                const sectionInnerHTML = new DOMParser().parseFromString(responseText, 'text/html');
                                const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                                const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
                                const newupdatecartPrice = sectionInnerHTML.getElementById('AjaxCartForm').dataset.carttotal;
                                const cartItems = document.getElementById('AjaxCartForm');
                                cartItems.innerHTML = cartFormInnerHTML;
                                cartItems.ajaxifyCartItems();
            
                                document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                                    elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                                });
                                document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
                                    elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
                                });
            
                                if ( alert !== null ) {
                                    this.form.prepend(alert);
                                } 
            
                                document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                                        console.log('dsd');
                              
                                const event = new Event('cart-updated');
                                current_this.dispatchEvent(event);
                                change_slider_location();
                                
                              })
                              .catch((e) => {
                                change_slider_location();
                                console.error(e); 
                              });
                          }
                        },
                        error: function() {
                          change_slider_location();
                        }
                      });
                }    

                render_cart();
          
            });
      }
  });
});

  
 });     

function change_slider_location() {
  var slider_nav = $('cart-recommendations .css-slider-navigation-container');
  $('cart-recommendations .cart_recommendations_header-arrow').html(slider_nav)
}
